import React, { useLayoutEffect, useEffect, useState, useRef, useContext} from "react";
import store from "@/redux/store";
import {storeCalenderSettings, setSelectedDate, getTasks, setSelectedUsers} from '@/reducers/CommunicationCycle';
import moment from 'moment';

interface ComponentState {
   items: any
}

class CalenderEventWidget extends React.Component<{}, ComponentState> {

    constructor(props:any) {
        super(props);
        let calenderEvents = store.getState().AuthReducer.calenderEvents;
        this.state = {items: ((calenderEvents) ? calenderEvents : [])}
    }
    
    render() {
        const {items} = this.state;
        
        if(!items || Array.isArray(items) && items.length == 0) {
            return (<></>);
        }
         
        return (<div className="eventPanel"><h5>Aankomende events</h5>
        {items && items.get().map((item, index) => {
            return (<div className="event">
                <span className="lblPanel">{item.name}</span>
                <span className="timePanel right">{item.getStartDate("DDD MMM HH:mm")}</span>  
            </div>)
        })}
        </div>);
    }
}

export default CalenderEventWidget;